export const META_ACCOUNTS_TABLE_HEADERS = Object.freeze([
	'Meta account',
	'Active add accounts',
	'Inactive add accounts',
	'Action',
]);

export const ADD_ACCOUNTS_TABLE_HEADERS = Object.freeze([
	'Name',
	'Source',
	'Add account ID',
	'Is Active',
	'Action',
]);
